// Dashboard.js
import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

import './../css/Dashboard.css';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';

import { Link, useNavigate } from 'react-router-dom';
import { collection, query, orderBy, getDocs, limit } from 'firebase/firestore';
import { db } from './../../firebase/firebaseConfig';; // Adjust import path as needed


export default function Dashboard() {

  const [firstName, setFirstName] = useState('');
  const auth = getAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, fetch their first name
        const userDocRef = doc(db, 'Users', user.uid); // Adjust 'Users' if your collection name is different
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          setFirstName(userDoc.data().firstname || ''); // Assuming 'firstname' field exists in Firestore
        }
      } else {
        // User is signed out
        setFirstName('');
      }
    });

    return () => unsubscribe(); // Clean up subscription on unmount
  }, [auth]);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate('/login'); // Redirect to login page after logout
      })
      .catch((error) => {
        console.error('Error logging out:', error);
      });
  };



  // Fetch Orders
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersCollection = collection(db, 'Orders');
        const q = query(ordersCollection, orderBy('orderDate', 'desc'), limit(10)); // Sort by orderDate in descending order
        const querySnapshot = await getDocs(q);
        
        const fetchedOrders = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOrders(fetchedOrders);
      } catch (error) {
        console.error('Error fetching orders: ', error);
      }
    };

    fetchOrders();
  }, []);
  return (
    <>
      <PageTitle title="Admin Sign In - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">{firstName && <p>Welcome, {firstName}!</p>}</h1>
     


        
        <div className="container mt-5">
          <h2 className='unbounded'>Orders</h2>
          <i>
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path></svg>
              The last 10 orders. <Link to='/a/orders'>
                <strong className="black-text">See all orders!</strong>
              </Link> 

          </i>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">S/N</th>
                <th scope="col">Order ID</th>
                <th scope="col">Contact Name</th>
                <th scope="col">Email</th>
                <th scope="col">View Details</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order,index) => (
                <tr key={order.id}>
                  <td scope="row">{index + 1}</td>
                  <th scope="row">{order.id}</th>
                  <td>{order.firstname} {order.lastname}</td> {/* Assuming name is composed of firstname and lastname */}
                  <td>{order.email}</td>
                  <td>
                    <Link className='black-button p' style={{fontSize: "12px"}} to={`/a/order/${order.id}`}>
                      Order Details
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Layout>
    </>
  );
}
